import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import LArtDeVivreEnUzege from "./sections/LArtDeVivreEnUzege";
import TheNeighborlyAdvantage from "./sections/TheNeighborlyAdvantage";
import HeroSection from "./sections/HeroSection";
import DigitalArchitecturePillars from "./sections/DigitalArchitecturePillars";
import GoogleReviews from "./sections/GoogleReviews";
import PersonalizedForYou from "./sections/PersonalizedForYou";
import RealStoriesFromSatisfiedUsers from "./sections/RealStoriesFromSatisfiedUsers";
import Contact from "./sections/Contact";
import BasDePageOsteomed from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <LArtDeVivreEnUzege />
      <TheNeighborlyAdvantage />
      <HeroSection />
      <DigitalArchitecturePillars />
      <GoogleReviews />
      <PersonalizedForYou />
      <RealStoriesFromSatisfiedUsers />
      <Contact />
      <BasDePageOsteomed />
    </div>;
}